import { USER_PHONE, USER_TOKEN } from '@utils/vars'

export const deleteUserDataFromlocalStorage = () => {
  const storage = window.localStorage
  storage.removeItem(USER_TOKEN)
  storage.removeItem(USER_PHONE)
}
